class Quantity {
  async init(): Promise<void> {
    const quantityWrappers = document.querySelectorAll(".quantity");

    quantityWrappers.forEach((quantityWrapper) => {
      const addBtn: HTMLButtonElement | null = quantityWrapper.querySelector(".quantity--button__plus");
      const removeBtn: HTMLButtonElement | null = quantityWrapper.querySelector(".quantity--button__minus");

      if (!addBtn || !removeBtn) {
        return;
      }

      const input: HTMLInputElement | null = quantityWrapper.querySelector(`input#${addBtn.dataset.target}`);

      if (!input) {
        return;
      }

      addBtn.addEventListener("click", () => {
        const currentValue = parseInt(input.value);
        const maxValue = parseInt(input.max);

        if (maxValue) {
          if (currentValue < maxValue) {
            input.value = (currentValue + 1).toString();
          }
        } else {
          input.value = (currentValue + 1).toString();
        }
      });

      removeBtn.addEventListener("click", () => {
        const currentValue = parseInt(input.value);
        const minValue = parseInt(input.min);

        if (currentValue > minValue) {
          input.value = (currentValue - 1).toString();
        }
      });
    });
  }
}

export default Quantity;
